<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">إدخال صورة</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "photoForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> الأسم</label>
                                <input class="form-control" id="validation01" type="text" formControlName="title"
                                [tooltip]="fc.title.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.title.valid && (fc.title.touched)"
                                [class.is-invalid]="fc.title.invalid && (fc.title.touched)"
                                
                                     required
                                     placeholder="الأسم"
                                    containerClass="" />
                            </div>
                          
                            <div class="col-6 mb-3">
                                <label for="validationCustom05"><span class="validation-required">*</span> ملف الصور </label>
                                <ng-select #Governorate  [selectOnTab]="true" formControlName="photoalbumid"
                                    class="form-control p-0" placeholder="اختر ملف الصور"
                                    containerClass="" 
                                    id="validationCustom05">
                                    <ng-option *ngFor="let item of photoalbum" [value]="item.id">{{item.title}}</ng-option>
                                </ng-select>
                            </div>
                        
                        </div>
                        <!-- insert image -->
                        <div class="col-6 my-3 " >
                            <img  src="{{ imageLogo }}" style="width: 60%; height: 220px;" class="image-style p-2" />
                           <input type="file" formControlName="branchImage" accept="image/*" #file id="getLogo"
                            style="display: none" (change)="getLogoUrl($event)" />
                        <button type="button" onclick="document.getElementById('getLogo').click()"
                            class="btn   d-block"  style="width: 60%;">
                            ارفاق صورة
                        </button>    
                                    </div>
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

